import React from 'react';
import cx from 'classnames';

import { getConfigProp, getDebugState } from '@atlas/core';

const DebugInfo = ({ withNav }) => {
  if (!getDebugState()) {
    return;
  }

  const commit = getConfigProp('commitVersion');
  const theme = getConfigProp('themeVersion');

  const className = cx('debug-info', { 'with-nav': withNav });

  return (
    <div className={className}>
      <div>Commit version: {commit}</div>
      <div>Dyeing version: {theme}</div>
    </div>
  );
};

export default DebugInfo;
